export default function calculateCollision({
  objectX,
  objectY,
  objectWidth,
  objectHeight,
  mouseX,
  mouseY,
}) {
  const minX = objectX;
  const maxX = objectX + objectWidth;

  const horizontalCollision = mouseX > minX && mouseX < maxX;

  const minY = objectY;
  const maxY = objectY + objectHeight;

  const verticalCollision = mouseY > minY && mouseY < maxY;

  return horizontalCollision && verticalCollision;
}



// WEBPACK FOOTER //
// ./src/calculateCollision.js